<template>
  <SectionPanel
    :title="{ value: brandDetails?.title ?? '' }"
    :description="{ value: brandDetails?.subTitle ?? '' }"
    :greyBg="{ value: true }"
  >
    <template #sectionPanelContent>
      <div v-if="brandDetails?.brands" class="grid grid-cols-1 lg:grid-cols-2 gap-2 mb-2">
        <div
          v-for="(brand, index) of brandDetails.brands"
          :key="index"
          class="flex items-center gap-4 rounded border-solid border-racq-pale-blue-border bg-racq-true-white border-2 p-4 mb-1"
        >
          <img :src="brand.fields.brand.value.src" :alt="brand.fields.brand.value.alt" class="h-14 w-14 mt-1" />
          <div class="lg:max-w-[170px] md:w-[100%] sm:w-[145px]">
            <RichText
              :field="brand.fields.benefitHeading"
              class="text-m-bold overflow-ellipsis whitespace-nowrap overflow-hidden -tracking-[0.15px]"
            />
            <RichText :field="brand.fields.benefitText" class="line-clamp-2"></RichText>
          </div>
          <div class="m-auto float-right">
            <Link
              v-if="brand.fields.link || brandDetails?.benefitsLink"
              :field="getLink(brand)"
              @click="() => pushAnalytics(`${OrdinalNumbers[index]} link`)"
            >
              <img
                src="@/assets/icons/arrow-right.svg"
                alt="Right pointing arrow icon"
                class="max-w-none h-[20px] w-[21px]"
              />
            </Link>
          </div>
        </div>
      </div>
      <Link
        :field="brandDetails?.benefitsLink"
        class="text-base-bold"
        @click="() => pushAnalytics(brandDetails.moreOffersText)"
        >{{ brandDetails.moreOffersText }}</Link
      >
    </template>
  </SectionPanel>
</template>

<script lang="ts" setup>
import { RichText, Link } from '@sitecore-jss/sitecore-jss-vue';
import { useI18n } from 'vue-i18n';
import SectionPanel from '@/components/SectionPanel/SectionPanel.vue';
import { IFormStep, IQuote } from '@/interfaces';
import { FormAnalyticsBuilder } from '@/utils/form-analytics-builder';
import { FormEvents } from '@/enums/form-events.enum';
import { OrdinalNumbers } from '@/constants/ordinal-numbers.const';

export interface IBenefitsBrands {
  brands: any[];
  benefitsLink: any;
  title: string;
  subTitle: string;
  moreOffersText: string;
}

const translation = useI18n();

const props = defineProps<{
  brandDetails: IBenefitsBrands;
  step: IFormStep;
  quote?: IQuote;
}>();

function getLink(brand: any) {
  const useBrandLink = (brand.fields.link?.value?.length ?? 0) > 0;
  return useBrandLink ? brand.fields.link : props.brandDetails?.benefitsLink;
}

function pushAnalytics(name: string) {
  if (props.quote) {
    const formAnalytics = new FormAnalyticsBuilder(props.quote, FormEvents.CROSS_SELL_CLICK, translation);
    formAnalytics.populateNavigation(name, props.brandDetails?.benefitsLink?.value?.url);
    formAnalytics.pushAnalytics();
  }
}
</script>

<style>
.overflow-ellipsis p {
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  float: left;
}
</style>
